module.exports = __webpack_public_path__ + "img/VolumeIcon.e2d40b9e.svg";